import {
    AnvilHookSpec,
    Component,
    ComponentConstructor,
    DropZone,
    HandleInteraction,
} from "@runtime/components/Component";
import { designerApi } from "@runtime/runner/component-designer-api";
import { BASE_MODULES } from "../python-environment";

const { DesignFlowPanel, FlowPanel } = BASE_MODULES["anvil"];

const getRandomStr = (len: number): string => {
    var r = "";
    for (var i = 0; i < len; i++) {
        r += String.fromCharCode(65 + Math.floor(26 * Math.random()));
    }
    return r;
};

const mkDropzone = () => {
    const element = document.createElement("div");
    element.setAttribute("anvil-flow-panel-dropzone", "true");
    return element;
};

const mkDesignerHookSpec = (oldHookSpec: AnvilHookSpec): Partial<AnvilHookSpec> => {
    return {
        enableDropMode(dropping) {
            const element = this.anvil$hooks.domElement!;
            const gutter = this._anvil.elements.gutter;
            const dzs: DropZone[] = [];
            let i = 0;
            for (const child of [...gutter.children]) {
                const dz = mkDropzone();
                child.insertAdjacentElement("beforebegin", dz);
                const childIdx = i++;
                dzs.push({
                    element: dz,
                    dropInfo: { minChildIdx: childIdx, maxChildIdx: childIdx },
                });
            }
            // TODO: Cleanup layout properties, or something equivalent.

            const endDz = mkDropzone();
            if (i === 0) {
                // There are no elements in this FlowPanel. Make sure the dropzone is the full width of the container
                element.insertAdjacentElement("beforeend", endDz);
            } else {
                // There are elements here already. Add this DZ at the end.
                gutter.insertAdjacentElement("beforeend", endDz);
            }
            dzs.push({
                element: endDz,
                dropInfo: { minChildIdx: i, maxChildIdx: i },
            });

            return dzs;
        },
        disableDropMode() {
            const element = this.anvil$hooks.domElement!;
            for (const dz of element.querySelectorAll("[anvil-flow-panel-dropzone]")) {
                dz.remove();
            }
        },
        getContainerDesignInfo(forChild: Component) {
            const oldHandles = this._anvil.getHandles(forChild);
            return {
                layoutPropertyDescriptions: [
                    {
                        name: "expand",
                        type: "boolean",
                        description: "Expand the component",
                        defaultValue: false,
                    },
                    {
                        name: "width",
                        type: "number",
                        description: "The width for an element that is not horizontally self-sizing",
                        defaultValue: null,
                    },
                ],
                interactions: oldHandles.map((h: any): HandleInteraction => {
                    h.pyChild = forChild;
                    let grabData: any = null;
                    return {
                        type: "handle",
                        position: "right",
                        direction: "x",
                        callbacks: {
                            grab: () => {
                                grabData = this._anvil.handleGrab(h, 0, 0);
                            },
                            drag: (dx, dy) => {
                                this._anvil.handleDrag(h, grabData, dx, dy, false);
                            },
                            drop: (dx, dy) => {
                                const { layoutProperties } = this._anvil.handleDrop(h, grabData, dx, dy);
                                designerApi.updateComponentProperties(forChild, {}, layoutProperties["undefined"]);
                            },
                        },
                    };
                }),
            };
        },
    };
};

export const DesignFlowPanelV3 = Sk.misceval.buildClass(
    BASE_MODULES["anvil"],
    function ($gbl, $loc) {
        const oldHookSpec = FlowPanel.prototype.anvil$hookSpec;
        $loc.anvil$hookSpec = Object.assign(Object.create(oldHookSpec), mkDesignerHookSpec(oldHookSpec));
    },
    "DesignFlowPanelV3",
    [DesignFlowPanel]
) as ComponentConstructor;
